var DailyGift = {

    locked: false,
    open: function () {
        let container = document.getElementById('daily_gift_box');
        let box = document.getElementById('gift_container');
        let content = document.getElementById('gift_container_data');
        let available = document.getElementById('available_count');
        if (!DailyGift.locked) {
            DailyGift.locked = true;
             Api.post('/dailygift/open', {}, function (r) {
                if (r.success) {
                    Alert.push([{type: 'success', text: 'El regalo diario ha sido sumado a tu cuenta.', icon: 'check'}]);
                    let operation = parseInt(available.textContent) - 1;
                    content.innerHTML = `<div rel="tooltip" data-name="${r.name}" data-description="${r.description}" style="background: url(/images/stickers_container.png),url(${r.image});background-size: 60px 60px,60px 60px;width:80px;height: 60px;"></div>`;
                    content.classList.add("d-flex");
                    content.classList.add("justify-content-center");
                    available.innerHTML = operation.toString();
                    DailyGift.locked = false
                } else {
                    switch (r.error.identifier) {
                        case 'already_opened':
                            container.remove();
                            Alert.push([{type: 'danger', text: '¡Oops! Ya has abierto el regalo del día de hoy.', icon: 'triangle-empty-alert'}]);
                            DailyGift.locked = false;
                            break;
                        case 'service_unavailable':
                          Alert.push([
                            {
                              type: 'danger',
                              text: '¡Hemos deshabilitado temporalmente la recolección de regalos diarios! Regresa pronto.',
                              icon: 'triangle-empty-alert'
                            }
                          ]);
                          DailyGift.locked = false;
                          break;
                    }
                }
            });
        }
    }


}
